/** The languages Trellistry speaks (design §8.1). */
export const locales = ['en-SG', 'zh-Hans-SG'];
export const sourceLocale = 'en-SG';
export const isLocale = (v) => locales.includes(v);
//# sourceMappingURL=locales.js.map